import { SubmitInsuranceInfoMutationVariables } from '../documents/SubmitInsuranceInfo.generated';
import { InsurancePlanData, InsuranceMemberData } from '../components/EnterInsuranceInfoForm';
import { isPolicyHolder } from './insuranceHelpers';

interface MapDataToInsuranceSubmission {
    submissionData: InsurancePlanData & InsuranceMemberData;
    employerInsuranceId?: string;
    email: string;
}

export const mapDataToInsuranceSubmission = ({
    submissionData,
    employerInsuranceId,
    email,
}: MapDataToInsuranceSubmission): SubmitInsuranceInfoMutationVariables => {
    const {
        firstName = '',
        lastName = '',
        sex = '',
        birthDate = '',
        addressLine1 = '',
        addressLine2 = '',
        addressCity = '',
        addressState = '',
        addressZip = '',
        subscriberId = '',
        policyNumber = '',
        relationshipCode = '',
        primaryFirstName,
        primaryLastName,
    } = submissionData;

    const memberInput = {
        firstName,
        lastName,
        gender: sex,
        dateOfBirth: birthDate,
        address: `${addressLine1} ${addressLine2}`.trim(),
        city: addressCity,
        state: addressState,
        postalCode: addressZip,
    };
    const planInput = {
        insurance: {
            policyMemberId: subscriberId,
            relationshipCode,
            primaryFirstName: isPolicyHolder(relationshipCode) ? firstName : primaryFirstName,
            primaryLastName: isPolicyHolder(relationshipCode) ? lastName : primaryLastName,
            policyNumber,
        },
        employerInsurance: {
            employerInsuranceId,
        },
    };
    const payerInput = {
        firstName,
        lastNameOne: lastName,
        emailAddress: email,
        addressOne: `${addressLine1}`.trim(),
        ...(!!addressLine2 && { addressTwo: addressLine2.trim() }),
        city: addressCity,
        state: addressState,
        zipCode: addressZip,
    };

    return { memberInput, planInput, payerInput };
};
